import { render, staticRenderFns } from "./length.vue?vue&type=template&id=438af9ec&scoped=true"
import script from "./length.vue?vue&type=script&lang=js"
export * from "./length.vue?vue&type=script&lang=js"
import style0 from "./length.vue?vue&type=style&index=0&id=438af9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438af9ec",
  null
  
)

export default component.exports